export default __webpack_public_path__ + "static/media/ambulance-management-system-compressed.0f2590a0.jpg";